'use strict';
// Google Universal Analytics tracking code wrapper:
// outputs:
// ga(
//  'send',
//  'event',
//  [ 'link' || customEventCategoty, eg: 'modal-dialog' ],
//  [ 'click' || customEventType, eg: 'hover' ],
//  [eventLabel]
// );
function gaTracker () {
  if (!window.ga || window.gtmDoesGaEvents) {
    return false;
  }

  if (window.wooGlobal && window.wooGlobal.noAnalytics) {
    return false;
  }

  var args = Array.prototype.slice.call(arguments);
  if (args && args[0].substring(0, 1) !== '_') {
    if (args.length === 1) {
      args.unshift('link', 'click');
    }

    args.unshift('send', 'event');
  }

  return window.ga.apply(this, args);
}

module.exports = gaTracker;
